import { createStyles } from '@material-ui/styles';

const styles = (): any =>
    createStyles({
        root: {},
    });

export default styles;
